import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const MUTUACORE_API_URL = process.env.REACT_APP_MUTUACORE_API_URL || 'https://sso.mutuacore.fr';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${MUTUACORE_API_URL}/auth/connexion`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, mot_de_passe: password })
      });

      const data = await response.json();

      if (response.ok) {
        if (data.mfa_requis) {
          setError('Code MFA requis — fonctionnalité à venir sur cette interface.');
          return;
        }

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);

        navigate('/dashboard');
      } else {
        setError(data.detail || 'Identifiants incorrects.');
      }
    } catch (err) {
      console.error("Erreur login:", err);
      setError('Erreur de connexion au serveur sécurisé.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ecf0f1', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', margin: '0 0 10px 0' }}>Audit Cyber Pro</h2>
          <p style={{ color: '#7f8c8d', margin: 0 }}>Connexion à votre espace client</p>
        </div>

        {error && <div style={{ background: '#e74c3c', color: 'white', padding: '10px', borderRadius: '5px', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>{error}</div>}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Email professionnel</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="contact@entreprise.com" />
          </div>

          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="••••••••" />
          </div>

          <p style={{ textAlign: 'right', margin: '0 0 20px 0' }}>
            <Link to="/mot-de-passe-oublie" style={{ color: '#3498db', textDecoration: 'none', fontSize: '13px' }}>Mot de passe oublié ?</Link>
          </p>

          <button type="submit" style={{ width: '100%', padding: '12px', background: '#2c3e50', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}>
            Se connecter
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px', color: '#7f8c8d' }}>
          Pas encore de compte ? <Link to="/register" style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}>S'inscrire</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;